export const loginRoutes = [
	{
		path: '/login',
		name: 'login-page',
		component: () => import('./pages/login-page/login-page.vue'),
		meta: {
			noPermission: true
		}
	},
	{
		path: '/reg',
		name: 'reg-page',
		component: () => import('./pages/reg-page/reg.vue'),
		meta: {
			noPermission: true
		}
	},
];
